import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState, TBoardId } from '../../../../types/types';
import { clickManagerActionSet } from '../store/clickManager/actions/clickManagerActionSet';
import { getSelectedLists } from '../selectors/getSelectedLists';
import { selectedListIdsSet } from '../store/clickManagerModel/actions/selectedListIdsSet';

export const deselectLists = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const selectedLists = getSelectedLists(state, boardId);
        if (selectedLists && selectedLists.length) {
            dispatch(clickManagerActionSet(boardId, selectedListIdsSet([], false)));
        }
    };
    return action;
};
